/**
 * Silicon | Multipurpose Bootstrap Template & UI Kit
 * Copyright 2023 Createx Studio
 * Theme core scripts
 *
 * @author Createx Studio
 * @version 1.6.0
 */

// Bootstrap
import 'bootstrap/dist/js/bootstrap.bundle'

// Smooth scroll
import 'smooth-scroll/dist/smooth-scroll.polyfills'

import './components/sticky-navbar'
import './components/smooth-scroll'
import './components/scroll-top-button'
import './components/password-visibility-toggle'
import './components/carousel'
import './components/gallery'
import './components/form-validation'
import './components/input-formatter'
import './components/tooltip'
import './components/popover'
import './components/toast'
import './components/video-button'
import './components/price-switch'
import './components/subscription-form'
import './components/hover-animation'

document
  .querySelectorAll('.offcanvas li a:not(.dropdown-toggle)')
  .forEach((link) => {
    link.addEventListener('click', () => {
      const navbarResponsive = document.getElementById('navbarNav')
      if (navbarResponsive.classList.contains('show')) {
        const navbarToggler = document.querySelector('.offcanvas-toggler')
        setTimeout(() => {
          navbarToggler.click()
        }, '100')
      }
    })
  })
